import { isDraftContent, isRichContent } from 'ricos-content';
import { isRichContentEqual } from 'ricos-content/libs/is-rich-content-equal';
import { ContentType } from '../../controller/services/comments-service-types';
import { isEqualWith } from 'lodash';
export const getCommentContent = (content) => {
    try {
        return content ? JSON.parse(content) : undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export const toCommentText = (content) => ({
    content: JSON.stringify(content),
    contentType: isDraftContent(content) ? ContentType.DRAFTJS : ContentType.RICH_CONTENT,
});
export const isCommentContentEqual = (content1, content2) => {
    if (!content1 || !content2) {
        return false;
    }
    if (isDraftContent(content1) && isDraftContent(content2)) {
        return isEqualWith(content1, content2, (_value, _other, indexOrKey) => {
            if (typeof indexOrKey === 'string' && ['metadata', 'id'].includes(indexOrKey)) {
                return true;
            }
            return undefined;
        });
    }
    if (isRichContent(content1) && isRichContent(content2)) {
        return isRichContentEqual(content1, content2);
    }
    return false;
};
//# sourceMappingURL=comment-content.js.map